import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from "axios"
import { ApiClientError } from "./ApiClientError"

class ApiService {
   private axiosInstance: AxiosInstance

   constructor(baseURL: string) {
      this.axiosInstance = axios.create({
         baseURL,
         timeout: 40000,
         headers: { "Content-Type": "application/json" },
      })
      this.setupInterceptors()
   }

   private setupInterceptors() {
      this.axiosInstance.interceptors.response.use(
         (response) => response,
         (error: AxiosError) => {
            const apiError = ApiClientError.fromAxios(error)

            console.error(
               "API error:",
               JSON.stringify({
                  message: apiError.message,
                  status: apiError.status,
                  payload: apiError.payload,
               }),
            )

            return Promise.reject(apiError)
         },
      )
   }

   public async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
      const response: AxiosResponse<T> = await this.axiosInstance.get(url, config)

      return response.data
   }

   public async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
      const response: AxiosResponse<T> = await this.axiosInstance.post(url, data, config)
      // console.log("Response from POST:", response.data)
      return response.data
   }

   public async patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
      const response: AxiosResponse<T> = await this.axiosInstance.patch(url, data, config)
      return response.data
   }

   public async delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
      const response: AxiosResponse<T> = await this.axiosInstance.delete(url, config)
      return response.data
   }

   // Add put, delete, etc. as needed
}
// console.log(
//    "ApiService initialized with base URL:",
//    process.env.BASE_DOMAIN ||
//       `${process.env.BASE_DOMAIN || process.env.NEXT_PUBLIC_BASE_DOMAIN || "http://localhost:3000"}` ||
//       "http://localhost:3000",

//    process.env.MAUTIC_URL || process.env.NEXT_PUBLIC_MAUTIC_DOMAIN || "https://mautic.restaurantassociation.com/api",
// )

export const apiService = new ApiService(
   `${process.env.BASE_DOMAIN || process.env.NEXT_PUBLIC_BASE_DOMAIN || "http://localhost:3000"}`,
)

export const mauticApi = new ApiService(`${process.env.MAUTIC_URL || process.env.NEXT_PUBLIC_MAUTIC_DOMAIN}`)

export const liveApi = new ApiService(`https://restaurantassociation.com/api`) //We don't use it

export const googleApi = new ApiService(`https://www.googleapis.com`)

export default ApiService
